export { default } from './StatusLabel';
